export default __webpack_public_path__ + "static/media/report1.c8a44c20.svg";